import React from 'react';

function PrivacyPage() {
  return (
    <main className="Page-content">
      <div className="Section Section--white u-h-100">
        <div className="Section-content">
          <div className="row u-pb-100">
            <div className="col-md-8 offset-md-2">
              <h1 className="Typography Typography--landingTitle u-weight-700 u-pb-24">
                Impressum
              </h1>

              <p className="u-weight-700 u-pb-24">Angaben gemäß § 5 TMG</p>

              <p>Ninebarc GmbH</p>

              <p>Skalitzer Str. 85-86</p>

              <p className="u-pb-24">10997 Berlin</p>

              <p className="u-weight-700">
                Vertreten durch die Geschäftsführung:
              </p>

              <p className="u-pb-24">Viktor Hettich</p>

              <p className="u-weight-700">Kontakt</p>
              <p>Tel.: 030 515652680</p>
              <p className="u-pb-24">
                E-Mail:&nbsp;
                <a
                  className="auto-generated-link"
                  data-auto-recognition="true"
                  data-content="info@ninebarc.com"
                  href="mailto:info@ninebarc.com"
                  data-type="mail"
                >
                  info@ninebarc.com
                </a>
              </p>

              <p className="u-weight-700">
                Handelsregisternummer und Umsatzsteuer-ID
              </p>

              <p>
                Eintragung im Handelsregister des Amtsgerichts
                Berlin-Charlottenburg HRB 216581 B
              </p>

              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:
              </p>

              <p className="u-pb-24">DE330258891</p>

              <p className="u-weight-700">EU-Streitschlichtung</p>

              <p>
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:&nbsp;
                <a
                  className="auto-generated-link"
                  data-auto-recognition="true"
                  data-content="https://ec.europa.eu/consumers/odr"
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-type="external"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>

              <p className="u-pb-24">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <p className="u-weight-700">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </p>

              <p>
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default PrivacyPage;
